import React, { useMemo } from 'react';
import {
  AlertTitle,
  Alert,
  Button,
  Paper,
  Toolbar,
  Typography,
  Box,
} from '@mui/material';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faSearchengin } from '@fortawesome/free-brands-svg-icons';
import { faPrint } from '@fortawesome/free-solid-svg-icons';
import { EditorControls } from '../../BaseEditor';
import Loader from '../../../components/MaterialUI/loader';
import usePrintContractInvoice from './hook';

const months = [...Array(12)].map((_, n) => {
  const d = new Date();
  d.setMonth(n);
  return {
    value: n,
    display_name: d.toLocaleDateString('uk', { month: 'long' }),
  };
});

function PrintInvoiceEditor() {
  const {
    org, onSetOrg, currentUser, loading, onGenerateForm,
    err, payer, setPayer, contract, setContract,
    mont, setMont, year, setYear, resultRef, printAllowed,
  } = usePrintContractInvoice();

  const payerFilter = useMemo(
    () => ({ org: org ? org.id : null }),
    [org],
  );
  const contractFilter = useMemo(
    () => ({ payer: payer ? payer.id : null, type: 6 }),
    [payer],
  );
  const contactDisabled = !(payer && payer.id);
  return (
    <Paper sx={{
      p: 2, height: 1, overflow: 'hidden', boxSizing: 'border-box', display: 'flex', flexDirection: 'column',
    }}
    >
      {loading && (
      <Loader text="Завантаження" />
      )}
      <Typography variant="h6" color="primary">
        Друк рахунків
      </Typography>
      {err && (
        <Alert severity="error">
          <AlertTitle>:-(</AlertTitle>
          {err}
        </Alert>
      )}
      { currentUser.is_superuser && (
      <EditorControls.ItemPicker
        value={org}
        onChange={(e, v) => onSetOrg(v)}
        backend="/api/catalog/orgs/"
        label="Установа"
      />
      )}
      <Box display="flex" gap={2}>
        <EditorControls.Selector
          label="Місяць"
          value={mont}
          values={months}
          onChange={(e, v) => setMont(v)}
        />
        <EditorControls.NumerInput
          label="Рік"
          value={year}
          minValue={2022}
          maxValue={2032}
          onChange={(e, v) => setYear(v)}
        />
        <EditorControls.ItemPicker
          label="Платник"
          value={payer}
          onChange={(e, v) => setPayer(v)}
          backend="/api/catalog/payers/"
          helpText="Заповнюється якщо треба сформувати рахунок лише по одному платнику"
          fitler={payerFilter}
        />
        <EditorControls.ItemPicker
          label="Договір"
          value={contract}
          onChange={(e, v) => setContract(v)}
          backend="/api/catalog/contracts/"
          helpText="Заповнюється якщо треба сформувати рахунок лише по одному договору"
          filter={contractFilter}
          disabled={contactDisabled}
        />
      </Box>
      <Toolbar sx={{ gap: 1 }}>
        <Button
          variant="contained"
          startIcon={<FontAwesomeIcon icon={faSearchengin} />}
          color="primary"
          disabled={loading}
          onClick={() => onGenerateForm()}
        >
          Сформувати рахунки
        </Button>
        <Button
          variant="contained"
          startIcon={<FontAwesomeIcon icon={faPrint} />}
          color="success"
          disabled={!printAllowed}
          onClick={() => window.print()}
        >
          Друк
        </Button>
      </Toolbar>
      <Box ref={resultRef} sx={{ overflow: 'auto' }} />
    </Paper>
  );
}

export default PrintInvoiceEditor;
